/**
 * The status the app shows for a SKU a full All Listings import no longer
 * carries (the listing was deleted in Seller Central). It replaces Amazon's
 * last-known status wherever the app shows, filters, or decides liveness by
 * status, so a deleted listing that was `Active` never reads as live. Not an
 * Amazon status: none is spelled this way. See docs/imports.md, "No longer
 * listed".
 */
export const DELISTED_STATUS = 'No longer listed';
